// Config Context - GoodPlace Konfiguration

import React, { createContext, useContext, ReactNode } from 'react';

// Feature Flags
export interface GoodPlaceFeatures {
  showAddPlace: boolean;
  showFavorites: boolean;
  showEvents: boolean;
  showReviews: boolean;
  showMap: boolean;
  showModeration: boolean;
}

// Configuration Interface
export interface GoodPlaceConfig {
  // Mode
  standalone: boolean;

  // Features
  features: GoodPlaceFeatures;

  // Callbacks
  onNavigate?: (path: string) => void;
  onPlaceSelect?: (placeId: string) => void;
  onAuthRequired?: () => void;
  onNotification?: (message: string, type: 'success' | 'info' | 'error') => void;
}

// Default Configuration
export const DEFAULT_CONFIG: GoodPlaceConfig = {
  standalone: true,
  features: {
    showAddPlace: true,
    showFavorites: true,
    showEvents: true,
    showReviews: true,
    showMap: false,
    showModeration: true,
  },
};

const ConfigContext = createContext<GoodPlaceConfig>(DEFAULT_CONFIG);

interface ConfigProviderProps {
  children: ReactNode;
  config?: Partial<GoodPlaceConfig>;
}

export function ConfigProvider({ children, config }: ConfigProviderProps) {
  const mergedConfig: GoodPlaceConfig = {
    ...DEFAULT_CONFIG,
    ...config,
    features: {
      ...DEFAULT_CONFIG.features,
      ...config?.features,
    },
  };

  return (
    <ConfigContext.Provider value={mergedConfig}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  return useContext(ConfigContext);
}

export default ConfigContext;
